export default __webpack_public_path__ + "static/730-2fd019a7c37b53ed43f4b6e327af4436.png";